"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactDraggable = _interopRequireDefault(require("react-draggable"));
var _reactUse = require("react-use");
var _Video = _interopRequireDefault(require("./Video/Video"));
var _VideoChatContext = require("./VideoChatContext");
require("./VideoChat.less");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var VideoChat = function VideoChat(_ref) {
  var allowFullScreen = _ref.allowFullScreen,
    _ref$isClinicianApp = _ref.isClinicianApp,
    isClinicianApp = _ref$isClinicianApp === void 0 ? false : _ref$isClinicianApp;
  var _useVideoChat = (0, _VideoChatContext.useVideoChat)(),
    containerOffset = _useVideoChat.containerOffset,
    isMaximized = _useVideoChat.isMaximized,
    isFullScreen = _useVideoChat.isFullScreen,
    onUnmountVideo = _useVideoChat.onUnmountVideo;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isVideoVisible = _useState2[0],
    setIsVideoVisible = _useState2[1];
  var _useState3 = (0, _react.useState)({
      x: 0,
      y: 0
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    dragPosition = _useState4[0],
    setDragPosition = _useState4[1];
  var body = (0, _react.useMemo)(function () {
    return document.querySelector('body');
  }, []);
  var videoRef = (0, _react.useRef)();
  var previousIsMaximized = (0, _reactUse.usePrevious)(isMaximized);
  var handleDrag = function handleDrag(e, data) {
    var x = data.x,
      y = data.y;
    setDragPosition({
      x: x,
      y: y
    });
  };

  // When video is maximized/minimized, reset offset from drag position
  (0, _react.useEffect)(function () {
    if (isMaximized) {
      setDragPosition({
        x: 0,
        y: 0
      });
    }
  }, [isMaximized]);

  // Prevent video from moving out of the viewport
  // when user resizes browser window
  (0, _react.useEffect)(function () {
    // Need to pass is maximized in deps array because of stale closure
    // So only invoke code when body size changes (and when video is minimized)
    if (!isMaximized && previousIsMaximized === isMaximized) {
      var _videoRef$current$get = videoRef.current.getBoundingClientRect(),
        left = _videoRef$current$get.left,
        right = _videoRef$current$get.right,
        top = _videoRef$current$get.top,
        bottom = _videoRef$current$get.bottom;
      if (left < 0) {
        setDragPosition(function (position) {
          return _objectSpread(_objectSpread({}, position), {}, {
            x: position.x + left * -1
          });
        });
      }
      if (top < 0) {
        setDragPosition(function (position) {
          return _objectSpread(_objectSpread({}, position), {}, {
            y: position.y + top * -1
          });
        });
      }
      if (right > body.clientWidth) {
        setDragPosition(function (position) {
          return _objectSpread(_objectSpread({}, position), {}, {
            x: position.x - (right - body.clientWidth)
          });
        });
      }
      if (bottom > body.clientHeight) {
        setDragPosition(function (position) {
          return _objectSpread(_objectSpread({}, position), {}, {
            y: position.y - (bottom - body.clientHeight)
          });
        });
      }
    }
  }, [body.clientHeight, body.clientWidth, isMaximized]);
  (0, _reactUse.useUnmount)(onUnmountVideo);
  return /*#__PURE__*/_react.default.createElement(_reactDraggable.default, {
    disabled: isMaximized,
    position: dragPosition,
    bounds: 'parent',
    onDrag: handleDrag
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('video-chat', {
      'clinician-call': isClinicianApp,
      hidden: !isVideoVisible,
      minimized: !isMaximized && !isFullScreen
    }),
    style: _objectSpread({
      position: 'fixed'
    }, containerOffset),
    ref: videoRef
  }, !isVideoVisible && /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: true,
    size: "large",
    className: (0, _classnames.default)('video-chat-placeholder', isClinicianApp && 'clinician-call')
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "video-container"
  }, /*#__PURE__*/_react.default.createElement(_Video.default, {
    allowFullScreen: allowFullScreen,
    isVideoVisible: isVideoVisible,
    setIsVideoVisible: setIsVideoVisible
  }))));
};
VideoChat.propTypes = {
  allowFullScreen: _propTypes.default.bool,
  isClinicianApp: _propTypes.default.bool
};
var _default = VideoChat;
exports.default = _default;